module.exports = "./img/0b0f4aed58d3a26dc4744e3a053f3644.jpg";